<template>
  <div class="downloads-consent-pricelist-modal">
    <div v-if="!downloads.isPriceListConsentGiven">
      <div class="downloads-consent-container">
        <div
          class="downloads-consent-form"
          :style="{ 'max-height': dynamicMaxHeight + 'px' }"
          @scroll="checkScroll"
          v-html="tStatic('priceListConsentForm')">
        </div>
      </div>
      <oie-action-wrapper>
        <oie-base-action
          size="large"
          theme="skeleton"
          @click="closeModal">
          {{ tStatic('priceListConsentDeny') }}
        </oie-base-action>
        <oie-base-action
          size="large"
          :disabled="!hasReadConsentForm"
          @click="confirmConsent">
          {{ tStatic('priceListConsentConfirm') }}
        </oie-base-action>
      </oie-action-wrapper>
    </div>
    <div v-else>
      <div class="downloads-consent-thankyou" v-html="tStatic('priceListConsentThankYou')">
      </div>
      <oie-action-wrapper>
        <oie-base-action size="large" @click="closeModal">
          {{ tStatic('priceListConsentContinue') }}
        </oie-base-action>
      </oie-action-wrapper>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dynamicMaxHeight: 0,
      isScrollComplete: false
    }
  },
  computed: {
    ...mapGetters('myDownloads', ['downloads']),
    hasReadConsentForm() {
      return this.isScrollComplete
    }
  },
  mounted() {
    this.dynamicMaxHeight = window.innerHeight * 0.7
  },
  methods: {
    ...mapActions('myDownloads', ['setPriceListConsentGdpr', 'getDownloads']),
    async confirmConsent() {
      if (!this.hasReadConsentForm) { return }
      await this.setPriceListConsentGdpr()
      this.options.confirmConsent()
    },
    closeModal() {
      this.options.declineConsent()
    },
    checkScroll() {
      const consentForm = document.querySelector('.downloads-consent-form')
      if (consentForm) {
        if (consentForm.scrollHeight - consentForm.scrollTop - 1 < consentForm.clientHeight) {
          this.isScrollComplete = true
        }
      }
    }
  }
}
</script>

<style lang="scss">

.downloads-consent-pricelist-modal {
  > h3 {
    @include h3-bold;
    margin: 0;
  }

  > p {
    margin: 1rem 0 1.5rem 0;
  }
}

.downloads-consent-container {
  margin-top: measure(half);
  margin-bottom: measure(half);
}

.downloads-consent-form {
  overflow-y: scroll;
}

.downloads-consent-thankyou {
  margin-bottom: measure(half);
}

</style>
